import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HbrButton } from '@harbor/elements-react-standalone';

type Props = {
  title?: string;
  message?: string;
  details?: string;
};

export default function ErrorPage({
                                    title = 'Something went wrong',
                                    message = 'An unexpected error occurred.',
                                    details,
                                  }: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div style={{ padding: 24, maxWidth: 900 }}>
      <h2 style={{ marginTop: 0, marginBottom: 8 }}>{title}</h2>
      <p style={{ marginTop: 0, marginBottom: 16 }}>{message}</p>

      <p style={{ marginTop: 0, marginBottom: 16, opacity: 0.75 }}>
        Path: <code>{location.pathname}</code>
      </p>

      {details ? (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontWeight: 600, marginBottom: 8 }}>Details</div>
          <pre style={{ padding: 12, background: '#f6f8fa', overflow: 'auto' }}>{details}</pre>
        </div>
      ) : null}

      <div style={{ display: 'flex', gap: 12 }}>
        <HbrButton onClick={() => navigate('/')}>Go to Home</HbrButton>
        <HbrButton sentiment="secondary" onClick={() => window.location.reload()}>
          Reload
        </HbrButton>
      </div>
    </div>
  );
}